import {AuthActions, AuthActionTypes} from './auth.actions';

export interface State {
    loggedIn: boolean;
    success: boolean;
    token: any;
    profile: any;
}

export const initialState: State = {
    loggedIn: false,
    success: undefined,
    token: undefined,
    profile: undefined
};

export function reducer(state = initialState, action: AuthActions): State {
    switch (action.type) {

        case AuthActionTypes.LoginSuccess: {
            return {
                ...state,
                loggedIn: true,
                token: action.payload.token,
                profile: action.payload.profile
            };
        }

        case AuthActionTypes.CheckAuthSuccess: {
            return {
                ...state,
                loggedIn: true,
                token: action.payload.token,
                profile: action.payload.profile
            };
        }

        case AuthActionTypes.LoginFailure: {
            return {
                ...state,
                loggedIn: false
            };
        }

        case AuthActionTypes.Logout: {
            return {
                ...state,
                loggedIn: false
            };
        }

        case AuthActionTypes.Set: {
            return {
                ...state,
                ...action.payload
            };
        }

        default:
            return state;
    }
}

export const getToken = (state: State) => state.token;
export const getLoggedIn = (state: State) => state.loggedIn;
export const getDidSucceed = (state: State) => state.success;
export const getProfile    = (state: State) => state.profile
